<template>
  <div>
    <div class="top">
      <div class="top-breadcrumbs">
        <!-- Predmeti<span class="current-breadcrumb"> Legroulx v. Pitre</span> -->
        <div class="left-crumbs-wrapper">
          <div @click="goTo($store.state.paginacija.back_link != '' ? $store.state.paginacija.back_link : '#')"
            :class="'privremeni-breadcrumb'">
            {{ this.$store.state.paginacija.title }}
          </div>
          <div class="current-breadcrumb" v-for="(page, key) in $store.state.paginacija.subpages" :key="key">{{ page }}
          </div>
        </div>
        <div class="mobile-menu-wrapper">
          <div class="mobile-menu">
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <NotificationComponent :sioVar="sioVar" />
      <div class="top-search">
        <div class="top-search-field">
          <input type="text" @keydown.esc="srch_txt = ''" placeholder="Pretraži.." v-model="srch_txt" />
        </div>
        <!-- <CustomDropdown :id="'drop-top-search'" :additional_classes="'top-search-group'" :custom_icon="1" v-model="search_filter"
                    :drop_items="drop_items" /> -->
        <div class="top-search-group">
          <select id="search-group" v-model="search_filter">
            <option value="1" selected>Sveobuhvatno</option>
            <option value="2">Predmete ili spise</option>
            <option value="3">Datoteke</option>
            <option value="4">Osobe ili institucije</option>
            <option value="5">Događaji</option>
            <option value="6">Projekti</option>
          </select>
          <div class="search-group-arrow"></div>
        </div>
        <div class="top-search-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
            <g>
              <g>
                <path fill="#fff"
                  d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z" />
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="top-right">
        <div class="top-notifications">
          <TasksDropdown ref="taskDrop" :sioVar="sioVar" />
          <div class="top-alarms">
            <div class="top-alarms-no">0</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20 25">
              <g>
                <g>
                  <path fill="#2b2b41"
                    d="M19.279 20.842a2.778 2.778 0 0 1-2.164 1.04h-4.294c0 1.59-1.261 2.882-2.812 2.882-1.55 0-2.812-1.293-2.812-2.881H2.885c-.84 0-1.628-.38-2.164-1.04a2.926 2.926 0 0 1-.6-2.373c.324-1.772.965-2.92 1.53-3.933.574-1.029 1.028-1.841 1.028-3.12v-1.44c0-3.785 2.79-6.952 6.374-7.429V1.142c0-.53.42-.96.938-.96s.937.43.937.96v1.403a7.177 7.177 0 0 1 4.27 2.176 7.546 7.546 0 0 1 2.105 5.255v1.44c0 .974.263 1.662.717 2.52a.972.972 0 0 1-.379 1.302.915.915 0 0 1-.445.116.934.934 0 0 1-.825-.504c-.456-.862-.943-1.91-.943-3.433v-1.44c0-3.029-2.395-5.526-5.34-5.57h-.177c-2.955.044-5.358 2.541-5.358 5.57v1.44c0 1.789-.648 2.95-1.274 4.073-.516.924-1.05 1.88-1.316 3.334a.966.966 0 0 0 .2.792c.106.13.339.347.722.347h14.23a.917.917 0 0 0 .721-.347.966.966 0 0 0 .2-.792.959.959 0 0 1 .75-1.121.939.939 0 0 1 1.093.767 2.926 2.926 0 0 1-.6 2.372zm-8.332 1.04H9.07c0 .53.421.961.938.961a.95.95 0 0 0 .938-.96z" />
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="top-user" id="dropdown-identificator" @click="isOpenDropDown = !isOpenDropDown">
          <!-- <div  class="top-user" id="dropdown-identificator"> -->
          <div class="top-username">{{ user.name }}</div>
          <div class="top-user-dropdown downarrow"></div>
          <div class="top-user-img" :style="avatar_class"></div>
        </div>
        <div class="top-user-menu">
          <div class="top-menu-top">
            <div @click="openUserDetails()" class="top-menu-img" :style="avatar_class"></div>
            <div class="user-menu1">
              <div @click="openUserDetails()" class="menu-top-username">{{ user.name }}</div>
              <div class="top-menu-mail">{{ user.userName }}</div>
            </div>
          </div>
          <div class="user-menu2">
            <div><a @click="openUserDetails()">Moj profil</a></div>
            <div><a @click="openProfile()">Uredi profil</a></div>
            <div v-if="admin_panel_acces"><a @click="openAdmin()">Admin ploča</a></div>
            <label for="upload" class="uredi-sliku">
              <div class="top-menu-settings">Uredi sliku</div>
              <input type="file" id="upload" accept=".jpeg" style="display: none" ref="file" @change="avatarChange()" />
            </label>
            <div class="odjava"><a @click="fullLogout()">Odjava</a></div>
          </div>
        </div>
      </div>
    </div>
    <!-- end class top -->
    <div class="dropdown-search-wrapper">
      <div class="dropdown_search" v-if="srch_txt != ''">
        <div class="search-row-center" v-if="nothingToShow">
          Nisu pronađeni nikakvi rezultati
        </div>
        <div class="search-title-wrapper" v-if="this.srch_predmeti != '' || this.srch_spisi != ''">
          <div class="search-title">Predmeti i spisi</div>
        </div>
        <div v-for="predmet in srch_predmeti" :key="predmet.group_url + '/predmet'" class="search-row"
          @click="closeDrop">
          <router-link :to="'/case/' + predmet.group_url + '/'" class="search-result">
            <div>
              <span class="search-label-wrapper">
                <span class="search-label"><img class="search-icon"
                    src="@/assets/img/search-predmet-icon.svg" />PREDMET</span>
              </span>
              {{ predmet.ime_predmeta }}
            </div>
          </router-link>
        </div>

        <!-- Spisi -->
        <div v-for="(spisi, key) in srch_spisi" :key="'300' + key">
          <div v-for="spis in spisi" :key="spis.id_spis + '/spisi'" class="search-row" @click="closeDrop">
            <router-link :to="'/case/' + spis.case_id + '/spisi/' + spis.id_spis" class="search-result">
              <span class="search-label-wrapper">
                <span class="search-label"><img class="search-icon"
                    src="@/assets/img/search-spis-icon.svg" />SPIS</span>
              </span>
              {{ spis.ime }}
              <!-- - <span class="search-label-imespisa">{{ spis.ime_predmeta}}</span> -->
            </router-link>
          </div>
        </div>
        <div class="search-title-wrapper" v-if="this.srch_projects != ''">
          <div class="search-title">Projekti</div>
        </div>
        <div v-for="proj in srch_projects" :key="proj.group_url + '/project'" class="search-row" @click="closeDrop">
          <router-link :to="'/projects/' + proj.group_url + '/'" class="search-result">
            <div>
              <span class="search-label-wrapper">
                <span class="search-label"><img class="search-icon"
                    src="@/assets/img/search-predmet-icon.svg" />PROJEKT</span>
              </span>
              {{ proj.name }}
            </div>
          </router-link>
        </div>

        <div class="search-title-wrapper" v-if="
          res_osobe != '' &&
          (res_osobe.res_fiz.length != 0 ||
            res_osobe.res_institucije.length != 0 ||
            res_osobe.res_odvjetnici.length != 0 ||
            res_osobe.res_pravna.length != 0 ||
            res_osobe.res_sluzbene.length != 0)
        ">
          <div class="search-title">Osobe i institucije</div>
        </div>
        <!-- fiz_osobe -->
        <div v-for="osoba in res_osobe.res_fiz" :key="'/osobe/fiz/' + osoba.uid" class="search-row" @click="closeDrop">
          <router-link :to="'/osobe/fiz/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{ osoba.status }}</span>
            </span>
            {{ osoba.ime }} {{ osoba.prezime }}
          </router-link>
        </div>
        <!--pravne osobe  -->
        <div v-for="osoba in res_osobe.res_pravna" :key="'/osobe/prav/' + osoba.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'/osobe/prav/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">{{ osoba.status }}</span>
            </span>
            {{ osoba.ime }}
          </router-link>
        </div>
        <!-- odvjetnici -->
        <div v-for="osoba in res_osobe.res_odvjetnici" :key="'/osobe/law/' + osoba.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'/osobe/law/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">ČLAN TIMA</span>
            </span>
            {{ osoba.ime }} {{ osoba.prezime }}
          </router-link>
        </div>
        <!-- sluzbene -->
        <div v-for="osoba in res_osobe.res_sluzbene" :key="'/osobe/leg-body/' + osoba.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'/osobe/leg-body/' + osoba.uid">
            <span class="search-label-wrapper">
              <span class="search-label">OSTALI</span>
            </span>
            {{ osoba.ime }} {{ osoba.prezime }}
          </router-link>
        </div>
        <!-- institucije -->
        <div v-for="inst in res_osobe.res_institucije" :key="'osobe/institucije/' + inst.uid" class="search-row"
          @click="closeDrop">
          <router-link :to="'osobe/institucije/' + inst.uid">
            <span class="search-label-wrapper">
              <span class="search-label">INSTITUCIJA</span>
            </span>
            {{ inst.naziv }}
          </router-link>
        </div>

        <!--events  -->
        <div class="search-title-wrapper" v-if="this.srch_events_list.length != ''">
          <div class="search-title">Događaji</div>
        </div>
        <div v-for="event in srch_events_list" :key="'/case/' + event.uid + '/kalendar'" class="search-row"
          style="cursor: pointer" @click="openEventDetails(event)">
          <!-- <router-link :to="'/case/' +event.predmet.group_url+ '/kalendar'"> -->
          <span class="search-label-wrapper">
            <span :class="[
              'search-label',
              'vrsta-eventa',
              'event-' + event.event_type.class_colour,
            ]">{{ event.event_type.name }}</span>
          </span>
          <span>
            {{ event.title }}
          </span>
          <!-- </router-link> -->
        </div>
        <div v-for="(event, key) in srch_events_list_private" :key="key" class="search-row"
          @click="openEventDetails(event)">
          <!-- <router-link :to="'/case/' +event.predmet.group_url+ '/kalendar'"> -->
          <span class="search-label-wrapper">
            <span :class="[
              'search-label',
              'vrsta-eventa',
              'event-' + event.event_type.class_colour,
            ]">{{ event.event_type.name }}</span>
          </span>
          <span>
            {{ event.title }}
          </span>
          <!-- </router-link> -->
        </div>
        <div v-if="isAnythingLoading" class="search-row">
          <div class="search-loader-dots">
            <div class="search-loader-dot"></div>
            <div class="search-loader-dot"></div>
            <div class="search-loader-dot"></div>
          </div>
        </div>
        <div class="search-title-wrapper" v-if="this.sp_res.length > 0">
          <div class="search-title">Datoteke</div>
        </div>

        <!-- sharepoint res -->
        <div v-for="(sp, key) in sp_res" :key="'100' + key" class="search-row" @click="closeDrop">
          <a :href="sp.resource.webUrl" target="blank" class="search-file-wrapper">
            <div class="search-file-left">
              <img class="search-icon-file search-icon-pdf" :src="returnFileType(sp.resource.name)" />
            </div>
            <div class="search-file-right">
              <div class="file-title">{{ sp.resource.name }}</div>
              <div class="summary" v-html="sp.summary"></div>
            </div>
          </a>
        </div>
      </div>
      <!-- end dropdown search -->
    </div>
    <CalendarModal v-if="this.$store.state.event_details.popup_open" :se="this.$store.state.event_details.chosen_event">
    </CalendarModal>
    <!-- end dropdown search wrapper-->
  </div>
</template>

<script>
import auth from "@/services/auth";
import person from "@/apiCallers/person";
import sharepoint_manager from "@/apiCallers/sharepoint";
import predmet_handler from "@/apiCallers/promise_handler_db/predmeti";
import project_handler from "@/apiCallers/promise_handler_db/projects";
import osobe_handler from "@/apiCallers/promise_handler_db/osobe_pr";
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue";
import NotificationComponent from "@/components/generalComponents/NotificationComponent.vue";
import TasksDropdown from "@/components/generalComponents/TasksDropdown.vue";
import $ from "jquery";
import gsap from "gsap";
import moment from "moment";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";

export default {
  components: { CalendarModal, NotificationComponent, TasksDropdown, CustomDropdown, },
  props: {
    user: {
      type: Object,
      required: true,
      default: null,
    },
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    isAnythingLoading() {
      return (
        this.loading_files ||
        this.loading_cases ||
        this.loading_events ||
        this.loading_persons ||
        this.loading_projects
      );
    },
    nothingToShow() {
      return (
        !this.isAnythingLoading &&
        this.srch_predmeti == "" &&
        this.srch_projects.length == 0 &&
        (this.srch_spisi == "") & (this.srch_events_list.length == "") &&
        this.sp_res.length == 0 &&
        (this.res_osobe == "" ||
          (this.res_osobe.res_fiz.length == 0 &&
            this.res_osobe.res_institucije.length == 0 &&
            this.res_osobe.res_odvjetnici.length == 0 &&
            this.res_osobe.res_pravna.length == 0 &&
            this.res_osobe.res_sluzbene.length == 0))
      );
    },
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("connection message", (data) => {
          console.log(data);
        });
        this.admin_panel_acces = this.$store.state.logged_in_user.admin_panel_acces

        // person
        //   .getUserPhoto(this.$store.state.logged_in_user.uid)
        //   .then((resp) => {
        //     let image = window.URL.createObjectURL(resp.data);
        this.avatar_class = { backgroundImage: "url(https://app-psod.cratis.cloud/" + this.$store.state.logged_in_user.uid + ".jpeg)" };
        // });

        this.sioVar.socket.on("new notification", (data) => {
          this.notifications.push(data);
          setTimeout(() => {
            gsap.fromTo(
              ".notif-" + data.uid,
              0.5,
              { x: 80, opacity: 0 },
              { x: 0, opacity: 1 }
            );
          }, 500);
        });
      }
    },
    isOpenDropDown: function () {
      if (!this.isOpenDropDown) {
        gsap.to(".top-user-dropdown", 0, { transform: "rotate(135deg)" });
        let tl = gsap.timeline();
        tl.fromTo(".top-user-menu", 0.3, { y: 0 }, { y: -20, opacity: 0 });

        tl.to(".top-user-menu", 0, { display: "none" });
        if (!this.$refs.taskDrop.isOpenTaskDrop) {
          gsap.to(".router-wrapper", 0.5, {
            filter: "none",
            pointerEvents: "auto",
            opacity: 1,
          });
        }
      } else {
        gsap.to(".top-user-dropdown", 0, { transform: "rotate(-45deg)" });
        let tl = gsap.timeline();
        tl.to(".top-user-menu", 0, { display: "block" });
        tl.fromTo(".top-user-menu", 0.3, { y: -20 }, { y: 0, opacity: 1 });
        gsap.to(".router-wrapper", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.5,
        });
      }
    },
    search_filter: function () {
      this.full_Search_activation();
    },
    srch_txt: function () {
      this.full_Search_activation();
      if (this.srch_txt == '') {
        this.search_open = false;
      }
      else {
        this.search_open = true;
      }
    },
  },
  methods: {
    openUserDetails(){
      this.$router.push('/osobe/law/'+this.$store.state.logged_in_user.uid)
      this.isOpenDropDown = false;
    },
    getUserAvatar() {

       person
          .getUserPhoto(this.$store.state.logged_in_user.uid)
          .then((resp) => {
            let image = window.URL.createObjectURL(resp.data);
            this.avatar_class = { backgroundImage: "url(" + image + ")" };
          });
    },
    async avatarChange() {
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      const formData = new FormData();
      for (const i of Object.keys(tmp_file_list)) {
        formData.append("avatar", tmp_file_list[i]);
      }

      formData.append("uid", this.$store.state.logged_in_user.uid);

      await person.addNewAvatar(formData).then(() => {
        this.getUserAvatar();
      });
    },
    async search_activation() {
      switch (this.search_filter) {
        case "1":
          this.authToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
          this.loading_files = true;
          this.loading_persons = true;
          this.loading_cases = true;
          this.loading_events = true;
          this.loading_projects = true;
          this.srch_all();
          break;
        case "2":
          this.loading_files = false;
          this.loading_persons = false;
          this.loading_cases = true;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_predmet_spis();
          break;
        case "3":
          this.authToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
          this.loading_files = true;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_sharepoint();
          break;
        case "4":
          this.loading_files = false;
          this.loading_persons = true;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = false;
          this.srch_osobe();
          break;
        case "5":
          this.loading_files = false;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = true;
          this.loading_projects = false;
          this.srch_events();
          break;
        case "6":
          this.loading_files = false;
          this.loading_persons = false;
          this.loading_cases = false;
          this.loading_events = false;
          this.loading_projects = true;
          this.search_projects();
          break;
      }
    },
    full_Search_activation() {
      this.sp_res = [];
      this.srch_spisi = [];
      this.srch_predmeti = [];
      this.srch_projects = [];
      this.srch_events_list = [];
      this.srch_events_list_private = [];
      this.res_osobe = [];
      //vrati search na mjesto
      if (this.srch_txt == "") {
        gsap.to(".top .top-search", 0, {
          left: "27%",
          right: "initial",
          margin: "initial",
          maxWidth: "initial",
        });
        if (window.matchMedia('(min-width: 1199px) and (max-width: 1570px)').matches) {
          gsap.to(".top .top-search", 0, {
            left: "30%",
            right: "initial",
            margin: "initial",
            maxWidth: "initial",
          });
        }
        gsap.to(".router-wrapper, .top-breadcrumbs, .top-right", 0.5, {
          filter: "none",
          pointerEvents: "auto",
          opacity: 1,
        });
        gsap.to(".dropdown_search", 0, { zIndex: "-1" });
      } else {
        this.loading_files = true;
        this.loading_persons = true;
        this.loading_cases = true;
        this.loading_events = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.search_activation();
        }, 1000);

        //pomakni search
        gsap.to(".top .top-search", 0, {
          left: "0",
          right: "0",
          margin: "auto",
          maxWidth: "63rem",
        });
        setTimeout(() => {
          gsap.to(".dropdown_search", 0, { zIndex: "999" });
        }, 100);
        gsap.to(".router-wrapper, .top-breadcrumbs, .top-right", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.2,
        });
      }
    },
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext];
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xls":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xlsx":
          return_val = require("@/assets/img/xls_icon.svg");
          break;

        default:
          return_val = require("@/assets/img/doc_icon.svg");
          break;
      }
      return return_val;
    },
    closeDrop() {
      this.srch_txt = "";
    },
    openEventDetails(event) {
      this.closeDrop();
      this.$store.state.event_details.popup_open = true;
      this.$store.state.event_details.chosen_event = event;
    },
    srch_all() {
      this.search_projects();
      this.srch_predmet_spis();
      this.srch_osobe();
      this.srch_sharepoint();
      this.srch_events();
    },
    srch_predmet_spis() {
      predmet_handler.searchPredmeti(this.srch_txt).then((resp) => {
        this.srch_spisi = resp.data.res_spisi;
        this.srch_predmeti = resp.data.res_predmeti;
        this.loading_cases = false;
      });
    },
    search_projects() {
      project_handler.searchProjects(this.srch_txt).then((resp) => {
        this.srch_projects = resp.data;
        // this.srch_spisi = resp.data.res_spisi;
        // this.srch_predmeti = resp.data.res_predmeti;
        this.loading_projects = false;
      });
    },
    srch_osobe() {
      // console.log("Pretražuje");
      osobe_handler.searchAll(this.srch_txt).then((resp) => {
        // console.log(resp.data);
        this.res_osobe = resp.data;
        this.loading_persons = false;
      });
    },
    srch_events() {
      // console.log("Pretražuje");
      person
        .getSearchEvents(this.$store.state.logged_in_user.uid, this.srch_txt)
        .then((resp) => {
          this.srch_events_list = resp.data.events_case;
          this.srch_events_list_private = resp.data.personal_events;
          this.loading_events = false;
        });
    },
    srch_sharepoint() {
      sharepoint_manager
        .searchDriveItems(this.authToken, this.srch_txt)
        .then((resp) => {
          if (resp.data.value[0].hitsContainers[0].total > 0) {
            resp.data.value[0].hitsContainers[0].hits.forEach((p) => {
              p.summary = p.summary
                .replace(/\<c0\>/g, '<span class="highlight">')
                .replace(/\<\/c0\>/g, "</span>");
              this.sp_res.push(p);
            });
          }
          this.loading_files = false;
        });
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    closeNotif(notif_uid) {
      // console.log(notif_uid);
      // gsap.fromTo('.notif-'+notif_uid, 0.5,{x:0, opacity:1},{x:80, opacity:0})
      this.notifications = this.notifications.filter(
        (not) => not.uid != notif_uid
      );
    },
    fullLogout() {
      auth.logout();
    },
    openProfile() {
      this.isOpenDropDown = !this.isOpenDropDown;
      this.$router.push("/personal-profile");
    },

    openAdmin() {
      this.isOpenDropDown = !this.isOpenDropDown;
      this.$router.push("/admin");
    },
    goTo(link) {
      this.$router.push(link)
    }
  },
  data() {
    return {
      image_url: null,
      loading_files: false,
      loading_persons: false,
      loading_cases: false,
      loading_events: false,
      loading_projects: false,
      isOpenDropDown: false,
      shortened_name: "",
      srch_txt: null,
      sp_res: [],
      srch_spisi: [],
      srch_predmeti: [],
      srch_projects: [],
      srch_events_list: [],
      srch_events_list_private: [],
      search_filter: "1",
      res_osobe: [],
      notifications: [],
      avatar_image_key: 1,
      authToken: "",
      avatar_class: {},
      search_open: false,
      admin_panel_acces: false,

      timeout: setTimeout(function () { }, 0),
      drop_items:[
          {id:"1", naziv:'Sveobuhvatno'},
          {id:"2", naziv:'Predmete ili spise'},
          {id:"3", naziv:'Datoteke'},
          {id:"4", naziv:'Osobe ili institucije'},
          {id:"5", naziv:'Događaji'},
          {id:"6", naziv:'Projekti'},
      ]
    };
  },

  async created() {
    this.shortened_name =
      this.user.name.split(" ")[0][0] + "" + this.user.name.split(" ")[1][0];
    this.authToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
  },
  mounted() {
    // click outside listener na dokumentu i ako je kliknuto izvan dropdowna ugasi
    //mozda ima bolji nacin
    var _this = this;
    $(document).click(function (e) {
      if (
        _this.isOpenDropDown && !$(e.target).is(
          "#dropdown-identificator, #dropdown-identificator *, .top-user-menu, .top-user-menu *"
        )
      ) {
        _this.isOpenDropDown = false;
      }
      if (
        _this.$refs.taskDrop.isOpenTaskDrop && !$(e.target).is(".top-tasks, .top-tasks *, .top-tasks-menu")
      ) {
        _this.$refs.taskDrop.isOpenTaskDrop = false;
      }
      if (
        _this.search_open && !$(e.target).is(".top-search, .top-search *, .dropdown-search-wrapper, .dropdown-search-wrapper *")
      ) {
        _this.srch_txt = ''
      }
    });
  },
  destroyed() {
    // $(document).off();
  },
};
</script>

<style>
</style>